import { FormBodyProps } from './types';

export const FormBody = ({ children }: FormBodyProps) => <form className="max-w-3xl">{children}</form>;